module.exports = require("core-js/modules/es.number.parse-float.js");